import { Component, output, signal } from '@angular/core';
import { faTimes, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';

export type RouterLinkEvent = {
  routerLink: string;
  shouldDoViewportCheck?: boolean;
};

@Component({
  selector: 'app-nav',
  imports: [FontAwesomeModule, RouterLink],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class Nav {
  onRouterLinkClick = output<RouterLinkEvent>();

  isNavVisible = signal<boolean>(false);

  faTimes = faTimes;
  faBars = faBars;

  toggleNav() {
    this.isNavVisible.update(isNavVisible => !isNavVisible);
  }
}
